import { SideTabType } from 'components/generics/buttons/SideTabs/types';
import { TopTabType } from 'components/generics/buttons/TopTabs/types';
import { PROFILE_TABS, TAB_MENU_ITEM, TABS_MENUS } from 'pages/profile/utils';
import { useCallback, useMemo, useState } from 'react';
import useUserDetails from '../../../hooks/requests/user/hooks/useUserDetails';

const useProfilePage = () => {
  const { isTenant } = useUserDetails();
  const [selectedTab, setSelectedTab] = useState<string>(PROFILE_TABS.ACCOUNT);

  const [chosenTab, setChosenTab] = useState<PROFILE_TABS>(
    PROFILE_TABS.ACCOUNT
  );

  const filteredTabs = useMemo(() => {
    const tabs = { ...TABS_MENUS };
    const profileToExclude = isTenant
      ? 'Investment Profile'
      : 'Resident Profile';

    tabs[PROFILE_TABS.ACCOUNT] = tabs[PROFILE_TABS.ACCOUNT].filter(
      (tab) => tab.label !== profileToExclude
    );

    return tabs;
  }, [isTenant]);

  const [chosenTabMenu, setChosenTabMenu] = useState<TAB_MENU_ITEM>(
    filteredTabs[chosenTab][0]
  );

  const onChangeTab = useCallback(
    ({ value }: TopTabType) => {
      const newTab = value as PROFILE_TABS;
      setChosenTab(newTab);
      setChosenTabMenu(filteredTabs[newTab][0]);
    },
    [filteredTabs]
  );

  const onChangeMenuTab = useCallback(
    ({ value }: SideTabType) => {
      const menu = filteredTabs[chosenTab];
      const newItem = menu.find((obj) => obj.label === value) as TAB_MENU_ITEM;
      setChosenTabMenu(newItem);
    },
    [filteredTabs, chosenTab]
  );

  return {
    chosenTab,
    setChosenTab,
    selectedTab,
    setSelectedTab,
    chosenTabMenu,
    setChosenTabMenu,
    filteredTabs,
    onChangeTab,
    onChangeMenuTab,
  };
};

export default useProfilePage;
